import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AccountStore } from '../store';
import { map, take } from 'rxjs/operators';
import { UserAccount } from '../store/models';

@Injectable()
export class AccountSelectorGuard implements CanActivate {
  constructor(private _accountStore: AccountStore, private _router: Router) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this._accountStore.getUserAccount().pipe(
      map(
        (userAccount: UserAccount) =>
          (userAccount && userAccount.hasMultipleAccounts) ||
          this._router.parseUrl('/login')
      ),
      take(1)
    );
  }
}
